// Closed-set label values for the auth-funnel Prometheus counters. They live in
// `scope:shared` — not next to the counters in `scope:core`, nor with the record
// helpers in `scope:auth` — because the emitters span scopes: `scope:auth` (signup
// modal, CPF form) and `scope:landing-pages` (CPF-monitor LP) may each depend on
// `scope:shared` but never on each other. One tuple, one guard, every consumer.
export const AUTH_FUNNEL_STEPS = [
  'signup_modal_rendered',
  'signup_modal_cta_clicked',
  'signup_modal_fallback_used',
  'signup_cpf_submitted',
  'signup_google_submitted',
  'signup_completed',
] as const
export type AuthFunnelStep = (typeof AUTH_FUNNEL_STEPS)[number]

export const AUTH_FUNNEL_STATUSES = ['success', 'failure', 'timeout', 'skipped'] as const
export type AuthFunnelStatus = (typeof AUTH_FUNNEL_STATUSES)[number]

export const makeAuthFunnelLabelGuard =
  <T extends string>(set: readonly T[]) =>
  (value: unknown): value is T =>
    typeof value === 'string' && (set as readonly string[]).includes(value)

export const isAuthFunnelStep = makeAuthFunnelLabelGuard(AUTH_FUNNEL_STEPS)
export const isAuthFunnelStatus = makeAuthFunnelLabelGuard(AUTH_FUNNEL_STATUSES)
